import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { Button as AntdButton, Flex, message } from 'antd';
import Icon from '../../../../../components/common/Icon';
import { LeftPanel, LeftPanelCard, LeftPanelCardBody, LeftPanelCardHead, LeftPanelContainer, PanelSearch, } from '../../../editor.style';
import AlphabetList from '../../../../../components/common/AlphabetList';
import { useSelector, useDispatch } from 'react-redux';
import { getSiteLanguagesAction } from '../../../../../store/mutliLanguageSlice';
const LanguageListPanel = ({ isOpen, addLanguage, onSelect, socket }) => {
    const [searchKey, setSearchKey] = useState('');
    const dispatch = useDispatch();
    // Retrieve the supported languages
    const supportedLanguagesResponse = useSelector((state) => state?.multiLanguage?.getSupportedLanguages?.response) || {};
    // Get the site's language data
    const siteLanguages = useSelector((state) => state.multiLanguage.getSiteLanguages.response?.content) || [];
    const siteId = useSelector((state) => state?.site?.checkSite?.response?.data?.siteId);
    // Map the siteLanguages to extract the multilingualId and a matching language name.
    const displayLanguages = siteLanguages?.map((lang) => {
        const code = lang?.destinationLanguage;
        const languageName = supportedLanguagesResponse[code] || code;
        return {
            multilingualId: lang?.multilingualId,
            name: languageName,
            buildStatus: lang?.buildStatus,
            destinationLanguage: code,
            disabled: lang?.disabled,
        };
    });
    // Function to generate Excel files via socket.
    const handleGenerateExcel = () => {
        if (!siteId) {
            return;
        }
        const id = siteId;
        const type = 'site';
        const data = { id, type };
        const channel = `/topic/site/${id}`;
        socket.emit('SUBSCRIBE', channel, data);
        socket.emit('GENERATE_MULTILINGUAL_EXCEL_FILE', siteId);
    };
    // Register a socket listener to log the response for the generation event.
    useEffect(() => {
        if (!socket)
            return;
        const handleExcelResponse = (data) => {
            if (data?.data?.status === 'BUILD_COMPLETED' && siteId) {
                dispatch(getSiteLanguagesAction(siteId)).then(() => {
                    message.success('Excel files generated successfully');
                });
            }
        };
        socket.on('GENERATE_MULTILINGUAL_EXCEL_FILE', handleExcelResponse);
        return () => {
            socket.off('GENERATE_MULTILINGUAL_EXCEL_FILE', handleExcelResponse);
        };
    }, [socket]);
    return (_jsx(LeftPanel, { isOpen: isOpen, style: { width: '320px' }, children: _jsx(LeftPanelContainer, { children: _jsxs(LeftPanelCard, { children: [_jsxs(LeftPanelCardHead, { children: [_jsxs(Flex, { align: "center", style: { marginBottom: 10 }, children: [_jsx("h3", { children: "Languages" }), _jsx(AntdButton, { color: "primary", variant: "text", onClick: handleGenerateExcel, children: "Generate Excel Files" }), _jsx(AntdButton, { color: "primary", variant: "text", icon: _jsx(Icon, { icon: "plus-circle" }), onClick: addLanguage })] }), _jsx(Flex, { align: "center", gap: 12, children: _jsx(PanelSearch, { placeholder: "Search Languages", variant: "filled", allowClear: true, prefix: _jsx(Icon, { icon: "search-md", size: 16 }), onChange: (e) => setSearchKey(e.target.value) }) })] }), _jsx(LeftPanelCardBody, { children: _jsx(AlphabetList, { hideCheckbox: true, searchKey: searchKey, data: displayLanguages?.map(({ name, multilingualId, buildStatus, destinationLanguage, disabled }) => ({
                                name,
                                id: multilingualId,
                                buildStatus,
                                destinationLanguage,
                                disabled,
                            })), onSelect: (id) => {
                                const selectedLanguage = displayLanguages.find((lang) => lang.multilingualId === id);
                                if (selectedLanguage) {
                                    const languageWithName = {
                                        ...selectedLanguage,
                                        languageName: selectedLanguage.name,
                                    };
                                    onSelect(languageWithName);
                                }
                            } }) })] }) }) }));
};
export default React.memo(LanguageListPanel);
